import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/mainlogo.png';
import Bars from '../../assets/bars.png';
import '../header/Header.css';

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Dynamically check if it's mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="header">
      <div className="header-content">
        <img src={Logo} alt="Logo" className="logo" />
        {isMobile && (
          <div
            className={`menu-toggle ${menuOpened ? 'open' : ''}`}
            onClick={() => setMenuOpened(!menuOpened)}
          >
            <img src={Bars} alt="Menu Bars" className="bars-icon" />
          </div>
        )}
      </div>
      <ul className={`header-menu ${menuOpened && isMobile ? 'open' : ''}`}>
      
        <li onClick={() => setMenuOpened(false)}>
          <Link to="/">Home</Link>
        </li>
        <li onClick={() => setMenuOpened(false)}>
          <Link to="/about">About</Link>
        </li>
        <li onClick={() => setMenuOpened(false)}>
          <Link to="/facility">Services</Link>
        </li>
        <li onClick={() => setMenuOpened(false)}>
          <Link to="/gallery">Gallery</Link>
        </li>
        <li onClick={() => setMenuOpened(false)}>
          <Link to="/contact">Contact</Link>
        </li>
        <li onClick={() => setMenuOpened(false)}>
          <Link to="/join">
            <button className="btns-join">Join Now</button>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Header;
